import { render, staticRenderFns } from "./CustomNavLink.vue?vue&type=template&id=bf261d32&scoped=true"
import script from "./CustomNavLink.vue?vue&type=script&lang=ts"
export * from "./CustomNavLink.vue?vue&type=script&lang=ts"
import style0 from "./CustomNavLink.vue?vue&type=style&index=0&id=bf261d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf261d32",
  null
  
)

export default component.exports